<template>
  
  <section class="relative" id="pricing-section" style="background:white">

			<div style="height: 495px;width: 100%;background: radial-gradient(at center top, rgb(234, 234, 234) 0%, rgb(255, 255, 255) 74%);position: absolute;top: 0px;left: 0px;z-index: 1;">.</div>
			<div style="height: 100px;width: 100%;background: linear-gradient(170deg, rgb(55, 71, 79), rgb(80, 97, 105));position: absolute;bottom: -83px;transform: rotate(179deg);opacity: 1;">.</div>

			<v-layout column wrap align-center class="pt-5 relative" style="z-index:6">

				<v-flex xs12 sm4>
					<div class="text-xs-center">
						<h2 class="display-2 font-weight-light mt-2 mb-4 pt-3">
							Pricing
						</h2>
					</div>
				</v-flex>

				<v-flex xs12>
					<v-container grid-list-xl class="mt-4">
						<v-layout row wrap align-center>


							<!--  FREE -->
							<v-flex sm12 lg3>
							<v-layout column align-center>
							<v-card class="pricing-container relative">

								<v-card-title primary-title>
									<v-layout column wrap align-center>
										<v-icon class="pricing-icon" id="free-plan-icon">directions_run</v-icon>
										<div class="title mt-2 mb-5">FREE</div>
										<div class="display-2 pricing-amount" style="background: #85d677;">$0</div>
										<span class="title pricing-words" >100 words</span>
									</v-layout>
								</v-card-title>
								<v-card-actions>
									<v-layout column wrap align-center class="mt-5">
										<v-btn class="elevation-0 pricing-button" @click='login()'>Start Now</v-btn>
									</v-layout>
								</v-card-actions>
							</v-card>
							</v-layout>
							</v-flex>

							<!--  BASIC -->
							<v-flex sm12 lg3>
							<v-layout column align-center>
							<v-card class="pricing-container relative">

								<v-card-title primary-title>
									<v-layout column wrap align-center class="">
										<v-icon class="pricing-icon">rowing</v-icon>
										<div class="title mt-2 mb-5">BASIC</div>
										<div class="display-2 pricing-amount">$5</div>
										<span class="title pricing-words" >400 words</span>
									</v-layout>
								</v-card-title>
								<v-card-actions>
									<v-layout column wrap align-center class="mt-5">
										<v-btn class="elevation-0 pricing-button" @click='login()'>Free Trial</v-btn>
									</v-layout>
								</v-card-actions>
							</v-card>
							</v-layout>
							</v-flex>

							<!--  EXTENDED -->
							<v-flex sm12 lg3>
							<v-layout column align-center>
							<v-card class="pricing-container relative">

								<v-card-title primary-title>
									<v-layout column wrap align-center class="">
										<v-icon class="pricing-icon">motorcycle</v-icon>
										<div class="title mt-2 mb-5">EXTENDED</div>
										<div class="display-2 pricing-amount relative">$10</div>
										<span class="title pricing-words" >1000 words</span>
									</v-layout>
								</v-card-title>
								<v-card-actions>
									<v-layout column wrap align-center class="mt-5">
										<v-btn class="elevation-0 pricing-button" @click='login()'>Free Trial</v-btn>
									</v-layout>
								</v-card-actions>
							</v-card>
							</v-layout>
							</v-flex>
							
							<!--  PREMIUM -->
							<v-flex sm12 lg3>
							<v-layout column align-center>
							<v-card class="pricing-container relative">

								<v-card-title primary-title>
									<v-layout column wrap align-center class="">
									<!--<v-icon>directions_run</v-icon>-->
										<v-icon class="pricing-icon">flight_takeoff</v-icon>
										<div class="title mt-2 mb-5">PREMIUM</div>
										<div class="display-2 pricing-amount relative">$15</div>
										<span class="title pricing-words" >2000 words</span>
									</v-layout>
								</v-card-title>
								<v-card-actions>
										<v-layout column wrap align-center class="mt-5">
											<v-btn class="elevation-0 pricing-button" @click='login()'>Free Trial</v-btn>
										</v-layout>
								</v-card-actions>
							</v-card>
							</v-layout>
							</v-flex>
						</v-layout>
					</v-container>
				</v-flex>
				<br/><br/><br/>

			</v-layout>

			<br/><br/><br/>
		</section>
  
  
</template>

<style>



.pricing-section {
	background-color: #f5f5f5 !important;
	}

	

	.pricing-container {
	width: 270px;
    --height: 365px;
    background: white !important;
    margin: 0px 1px;
    border: 1px solid #eaeaea;
    margin-bottom: 1.5rem;
    overflow: hidden;
    position:relative;
    top:0px;
    transition:top 0.5s;
    margin-bottom: 1.5rem;
    padding-bottom:2rem;
    box-shadow:0px 3px 4px -1px rgba(38, 111, 74, 0.2) !important;
	}
	
	@media (min-width: 1264px) {
	.pricing-container {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
	}
}

	.pricing-container:hover .pricing-icon {
		--left:-10px;
		color:rgb(228, 186, 107) !important;
	}

	.pricing-container:hover #free-plan-icon {
		color:rgb(133, 214, 119) !important;
	}

	.pricing-container:hover {
		background:white !important;
		--box-shadow:0 0 0px 8px rgba(235, 156, 37, 0.21) !important;
		--box-shadow:0 0 0px 8px rgba(235, 156, 37, 0.21) !important;
		top:-10px;
	}

	.pricing-button {
		background: transparent !important;
		border: 1px solid #929090;
	}

	.pricing-container:hover .pricing-button {
		background:#15b681 !important;
		border: 1px solid #15b681;
		color:white !important;
	}

	.pricing-container:hover .pricing-amount {
		transform:scale(1.1);
		transition:transform 0.8s;
	}

	.pricing-amount {
		background:rgb(0, 186, 220);
		background:rgb(228, 186, 107);
		color:white;
		padding:17px;
		border-radius: 0px 45px 45px 45px;
		--margin-bottom:6px;
		width: 110px;
        text-align: center;
        z-index:5;
        transition:transform 3s;
	}

	.pricing-words {
		color:rgb(102, 104, 105);
		z-index:5;
		padding-top:15px;
	}

	.pricing-icon {
    color: rgb(103, 103, 103) !important;
    z-index: 1;
    font-size: 3rem;
    border-bottom: 1px solid #d8d8d8;
    padding: 10px;
    padding-bottom: 5px;
	}

	.pricing-container-header {
	height:50px;
	width:100%;
	}


</style>

<script>
import {Auth} from '../auth/cognito_auth';

export default {
  name: "pricing_section",
  data() {
    return {
    };
  },
  methods: {
		login : function() {
				Auth.login();
		}
  }
};
</script>


